// shared/hooks/useNavbar.js
import { useEffect, useState } from 'react';
import api from '../../../../api/axios';

export const useNavbar = (slug) => {
  const [telefono, setTelefono] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTelefono = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/users/public/user/${slug}/phone`);
      setTelefono(response.data.telefono);
      setError(null);
    } catch (error) {
      console.error('Error al obtener el número de teléfono:', error);
      setError('No se pudo cargar el teléfono');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) {
      fetchTelefono();
    }
  }, [slug]);

  return { telefono, loading, error };
};